import { Route } from 'react-router-dom';

import { DockerImageOverview } from './docker-image-overview';
import { DockerImageUpdate } from './docker-image-update/docker-image-update.component';

export function DockerImageRoutes() {
    return (
        <Route path='docker-images'>
            <Route
                index
                element={<DockerImageOverview />}
            />

            <Route path=':imageId'>
                <Route
                    path='update'
                    element={<DockerImageUpdate />}
                />
            </Route>
        </Route>
    );
}
